import React from 'react';

import { Skeleton, SkeletonProps } from '@bcp-nextgen-dx-component-factory/design-system';

type BaseSkeletonProps = Partial<SkeletonProps>;

export const BaseSkeleton: React.FC<BaseSkeletonProps> = (props) => {
	return <Skeleton {...(props as any)} />;
};
